import { Spin } from "antd";
import React from "react";
import "./ChantSpinner.css";

const ChantSpinner = ({
  isScreenLoader = false,
  text = "",
  size = "large",
  ...props
}) => {
  return (
    <div
      className="flex-center"
      style={isScreenLoader ? { minHeight: "300px", width: "100%" } : {}}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
        <Spin className="chant-spinner" size={size} {...props} />
        {text && <p style={{ color: "#3a3a3a" }}>{text}</p>}
      </div>
    </div>
  );
};

export default ChantSpinner;
